<template>
  <div v-if="days.length > 0">
    <small v-if="allPassed" class="text-danger">
      {{ trans(!!cls && cls.is_team ? 'no_upcoming_game' : 'no_upcoming_class') }}
    </small>
    <small v-if="!showCustomScheduleOnInvoice && upcomingEvents.length > 0 && !hideUpcoming && !cls.show_custom_schedule_on_invoice" class="text-success">
      {{ upcomingEvents.length }}<span v-if="upcomingEvents.length != events.length">/{{ events.length }}</span> {{ trans('upcoming').toLowerCase() }}
    </small>
    <small v-if="!!customSchedule && this.hideSchedule == false" v-html="customSchedule" class="d-block"></small>
    <div v-if="!customSchedule && this.hideSchedule == false">
      <div
        v-for="(sch, index) in theSchedule"
        v-if="!hideTimes && (show_more || index < 1)"
        :key="'sch'+index"
        class="mb-1"
      >
        <small class="d-block">{{ mustTruncate ? truncate(sch[0]) : sch[0] }}</small>
        <small class="d-block">{{ mustTruncate ? truncate(sch[1]) : sch[1] }}</small>
      </div>
      <small
        v-for="(day, index) in days"
        v-if="hideTimes && (show_more || index < 1)"
        :key="'day'+index"
        class="d-block mb-1">
        {{ moment(day).format('LL') }}
      </small>
      <small v-if="theSchedule.length > 1 || mustTruncate" class="d-block">
        <b-button variant="link" size="sm" class="p-0 text-muted" @click="onToggle">
          <span v-if="!show_more">
            {{ trans('more').toLowerCase() }}
            <i class="fa fa-fw fa-chevron-right"></i>
          </span>
          <span v-if="show_more">
            <i class="fa fa-fw fa-chevron-left"></i>
            {{ trans('less').toLowerCase() }}
          </span>
        </b-button>
      </small>
    </div>
  </div>
</template>

<script>

  function has_event_passed(organization, cls, event, now)
  {
    if (!now) now = moment()
    let start = moment(event.start)
    if (cls && cls.registration_stop_minutes !== null) {
      start.add(-cls.registration_stop_minutes, 'minute')
    } else {
      start.endOf('day')
    }
    return now.isAfter(start)
  }

  export default {
    props: {
      organization: Object,
      cls: Object, // Used to determine registration period and limits
      events: Array,
      schedule: Array, // When null, we use cls.schedule
      customSchedule: String, // When set, overrides what we show
      hideTimes: {
        type: Boolean,
        default: false,
      },
      hideUpcoming: {
        type: Boolean,
        default: false,
      },
      hideSchedule: {
        type: Boolean,
        default: false
      },
      showCustomScheduleOnInvoice: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        compact: _.compact,
        truncate: _.truncate,
        show_more: false,
        show_passed: false,
      }
    },
    computed: {
      theSchedule() {
        return this.schedule || this.cls.schedule
      },
      mustTruncate() {
        return !this.show_more &&
          this.theSchedule.length > 0 &&
          (this.theSchedule[0][0].length > 30 || this.theSchedule[0][1].length > 30)
      },
      allPassed() {
        return _.reduce(this.events || [], (all_passed, e) => {
          if (!has_event_passed(this.organization, this.cls, e)) all_passed = false
          return all_passed
        }, true)
      },
      hasPassed() {
        return _.reduce(this.events || [], (has, e) => {
          if (has_event_passed(this.organization, this.cls, e)) has = true
          return has
        }, false)
      },
      upcomingEvents() {
        return _.reduce(this.events || [], (upcoming, e) => {
          if (!has_event_passed(this.organization, this.cls, e)) upcoming.push(e)
          return upcoming
        }, [])
      },
      days() {
        return _.reduce(this.events || [], (days, e) => {
          let day = moment(e.start).format('YYYY-MM-DD')
          if (days.indexOf(day) === -1) days.push(day)
          return days
        }, [])
      },
    },
    watch: {
      upcomingEvents() {
        this.$emit('upcoming', this.upcomingEvents)
      },
    },
    methods: {
      onToggle() {
        this.show_more = !this.show_more
        if (this.show_more && this.allPassed && !this.show_passed) this.show_passed = true
      },
    },
    mounted() {
      window.eventsSchedule2 = this
      this.$nextTick(() => {
        this.$emit('upcoming', this.upcomingEvents)
      })
    },
  }
</script>
